import React from 'react'

export const widgetVideoPrototype = [
]

const Video = ({value}) => {
    return (
        <video controls width="250">
            <track default kind="captions" srcLang="de" label="Deutsch"/>
            <source src={value} type="video/mp4"/>
            Leider unterstützt ihr Browser keine Videos.
        </video>
    )
}

export default Video